import type { Game, GameWrite, Member } from "./types";
import { apiClient } from "./lib/api-client";

const request = apiClient;

export const api = {
  me: () => request<Member>("/api/v1/gamer-zone/me"),
  games: () => request<Game[]>("/api/v1/gamer-zone/games"),
  rateGame: (id: number, score: number) =>
    request<Game>(`/api/v1/gamer-zone/games/${id}/rating`, {
      method: "POST",
      body: JSON.stringify({ score })
    }),
  favoriteGame: (id: number, favorited: boolean) =>
    request<Game>(`/api/v1/gamer-zone/games/${id}/favorite`, {
      method: "PUT",
      body: JSON.stringify({ favorited })
    }),
  commentGame: (id: number, body: string) =>
    request<Game>(`/api/v1/gamer-zone/games/${id}/comments`, {
      method: "POST",
      body: JSON.stringify({ body })
    }),
  createGame: (payload: GameWrite) =>
    request<Game>("/api/v1/gamer-zone/admin/games", {
      method: "POST",
      body: JSON.stringify(payload)
    }),
  updateGame: (id: number, payload: GameWrite) =>
    request<Game>(`/api/v1/gamer-zone/admin/games/${id}`, {
      method: "PUT",
      body: JSON.stringify(payload)
    }),
  deleteGame: (id: number) =>
    request<void>(`/api/v1/gamer-zone/admin/games/${id}`, {
      method: "DELETE"
    })
};
